"use strict";

angular.module('app.factories.devices', []).

// -------------------------------------------//
//             Devices Factory
// -------------------------------------------//
factory('f_Devices', [
    function () {

        var devices ;

        var obj = {
            getDevices: function () {
                return (devices) ? devices : [];
            },
            setDevices : function(a,init)
            {
                // Only $encoded data !
                if(init){
                    devices = a;
                }else{
                    if(a && a.length >0){
                        for (var i = 0; i < devices.length; i++) {
                            this.addOrUpdateDevice(devices[i]);
                        }
                    }
                }
                return devices;
            },
            addOrUpdateDevice : function(d)
            {
                var found = false;
                if(!devices)
                {
                    return;
                }
                for (var i = devices.length - 1; i >= 0; i--) {
                    if(devices[i].DeviceId == d.DeviceId){
                        found = true;
                        devices[i].updateDeviceData(d);
                    }
                }
                if(!found)
                {
                    devices.push(d);
                }
                return d;
            },
            getById: function (id) {
                for(var i = 0; i < devices.length; i++)
                {
                    if(devices[i].DeviceId == id){
                        return devices[i];
                    }
                }
                return ;
            },
            getDeviceById: function (d) {
               return obj.getById(d);
            }
        };


        return obj;
    }]);
